import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FormEntry from '../../../models/FormEntry'
import { Button, Icon } from 'semantic-ui-react'
import { observer } from 'mobx-react'

@observer
class Duplicate extends Component {
  static propTypes = {
    name: PropTypes.string,
    btnLabel: PropTypes.string,
    equipment: PropTypes.instanceOf(FormEntry),
    renderGroup: PropTypes.func.isRequired
  }

  static defaultProps = {
    btnLabel: 'Équipement'
  }

  handleAddLine = () => {
    const { name, equipment } = this.props
    const iterations = parseInt(equipment.getValue(name, false, '1'))
    equipment.updateValue(name, (iterations + 1))
  }

  handleRemoveLine = () => {
    const { name, equipment } = this.props
    const iterations = parseInt(equipment.getValue(name, false, '1'))
    if (iterations <= 0) {
      return
    }
    equipment.updateValue(name, (iterations - 1))
  }

  render () {
    const { name, equipment, renderGroup, btnLabel } = this.props
    const iterations = parseInt(equipment.getValue(name, false, '1'))
    return (
      <>
        {!equipment.readonly &&
          <>
            <Button icon onClick={this.handleAddLine}><Icon name='add' /> {btnLabel}</Button>
            <Button icon onClick={this.handleRemoveLine} color='red'><Icon name='delete' /> {btnLabel}</Button>
          </>}
        {[...Array(iterations)].map((value, index) => {
          return renderGroup(index)
        })}
        {!equipment.readonly &&
          <>
            <Button icon onClick={this.handleAddLine}><Icon name='add' /> {btnLabel}</Button>
            <Button icon onClick={this.handleRemoveLine} color='red'><Icon name='delete' /> {btnLabel}</Button>
          </>}
      </>
    )
  }
}
export default Duplicate
